interface TicketTypeRowData {
  id: string
  name: string
  description: string
  price: string
  capacity: string
}

interface Props {
  row: TicketTypeRowData
  index: number
  total: number
  onChange: (id: string, field: keyof TicketTypeRowData, value: string) => void
  onRemove: (id: string) => void
  onMoveUp: (id: string) => void
  onMoveDown: (id: string) => void
}

export function TicketTypeRow({ row, index, total, onChange, onRemove, onMoveUp, onMoveDown }: Props) {
  const inputClass =
    'w-full px-2.5 py-1.5 rounded-lg border border-gray-200 text-sm text-gray-900 placeholder:text-gray-400 bg-white focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500'

  return (
    <div className="flex items-start gap-2 py-2 border-b border-gray-100 last:border-0">
      {/* Ordre */}
      <div className="flex flex-col gap-0.5 pt-1 shrink-0">
        <button
          type="button"
          onClick={() => onMoveUp(row.id)}
          disabled={index === 0}
          className="p-0.5 rounded text-gray-400 hover:text-gray-600 disabled:opacity-30"
        >
          <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <polyline points="18 15 12 9 6 15"/>
          </svg>
        </button>
        <button
          type="button"
          onClick={() => onMoveDown(row.id)}
          disabled={index === total - 1}
          className="p-0.5 rounded text-gray-400 hover:text-gray-600 disabled:opacity-30"
        >
          <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </button>
      </div>

      {/* Nom */}
      <div className="flex-1 min-w-0">
        <input
          type="text"
          value={row.name}
          onChange={(e) => onChange(row.id, 'name', e.target.value)}
          placeholder="Nom (ex: Normal)"
          className={inputClass}
        />
      </div>

      {/* Description */}
      <div className="flex-1 min-w-0 hidden sm:block">
        <input
          type="text"
          value={row.description}
          onChange={(e) => onChange(row.id, 'description', e.target.value)}
          placeholder="Description (optionnel)"
          className={inputClass}
        />
      </div>

      {/* Prix */}
      <div className="w-28 shrink-0">
        <div className="relative">
          <input
            type="number"
            value={row.price}
            onChange={(e) => onChange(row.id, 'price', e.target.value)}
            placeholder="0"
            min="0"
            className={`${inputClass} pr-12`}
          />
          <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-xs text-gray-400 pointer-events-none">
            FCFA
          </span>
        </div>
      </div>

      {/* Capacité */}
      <div className="w-24 shrink-0">
        <input
          type="number"
          value={row.capacity}
          onChange={(e) => onChange(row.id, 'capacity', e.target.value)}
          placeholder="0"
          min="0"
          className={inputClass}
          title="0 = Illimité"
        />
        {row.capacity === '0' || row.capacity === '' ? (
          <p className="text-xs text-gray-400 mt-0.5 pl-0.5">Illimité</p>
        ) : null}
      </div>

      {/* Supprimer */}
      <button
        type="button"
        onClick={() => onRemove(row.id)}
        disabled={total <= 1}
        className="shrink-0 p-1.5 rounded-lg text-gray-400 hover:text-danger-600 hover:bg-danger-50 transition-colors disabled:opacity-30 disabled:cursor-not-allowed mt-0.5"
      >
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="3 6 5 6 21 6"/>
          <path d="M19 6l-1 14H6L5 6"/>
          <path d="M10 11v6M14 11v6"/>
          <path d="M9 6V4h6v2"/>
        </svg>
      </button>
    </div>
  )
}

export type { TicketTypeRowData }
